/**
* GENERATED BY KRPC GEN - LESS MODIFY BY HAND
* upload-service.ts  2025-08-12T13:43:44+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'krpc-base';

import type { UploadAuthReq, UploadToken } from './wy-dto';

const _ = 'Upload/';

export class UploadService {

  constructor(readonly r: RpcService) {}
  // 获取OSS公有空间基准URL，以斜杠结尾。客户端可缓存, 示例：https://oss.wangyuedaojia.com/
  getPublicOssBaseHref(m?: M): R<string>{
    return this.r.async(_ + 'getPublicOssBaseHref', undefined, m);
  }
  // 获取OSS公有空间文件上传权限信息
  getPublicOssUploadAuth(d:UploadAuthReq, m?: M): R<UploadToken>{
    return this.r.async(_ + 'getPublicOssUploadAuth', d, m);
  }
}
